(ns quuppa.qsm.api-keys.events
  (:require [re-frame.core :as rf :refer [reg-event-fx]]
            [quuppa.peweb.query :as q]))

(def api-keys-query (q/create-query :api-keys/list-api-keys [:qpe-identity]))

(rf/reg-event-db
  :api-keys/add
  (q/update-event-fn api-keys-query
                     (fn [result {:keys [api-key]}]
                       (if (some #(= (:id %) (:id api-key)) result)
                         result
                         (conj result api-key)))))


(rf/reg-event-db
  :api-keys/remove
  (q/update-event-fn api-keys-query (fn [result event]
                                      (into (empty result)
                                            (remove #(= (:id %) (:id event)) result)))))

(reg-event-fx
  :qsm/revoke-api-key
  (fn [_ [_ qpe-identity id]]
    {:fx [[:server-dispatch {:event [:qsm/revoke-api-key {:id id}]
                             :on-success [::api-key-revoked qpe-identity id]}]]}))

(reg-event-fx
  :qsm/generate-api-key
  (fn [_ [_ qpe-identity form]]
    {:fx [[:server-dispatch {:event      [:qsm/generate-api-key (assoc form :qpe-identity qpe-identity)]
                             :on-success [::api-key-added qpe-identity]
                             :on-error [::api-key-added-error qpe-identity]}]]}))

(rf/reg-event-fx
  ::api-key-added-error
  (fn [{:keys [db]} [_ qpe-identity error]]
    {:db (assoc-in db [:qpes qpe-identity :ui :sidebar :error] error)}))

(rf/reg-event-fx
  ::api-key-added
  (fn [{:keys [db]} [_ qpe-identity new-api-key]]
    {:db (assoc-in db [:qpes qpe-identity :ui :sidebar :new-api-key] new-api-key)}))

(rf/reg-event-fx
  ::api-key-revoked
  (fn [{:keys [db]} [_ qpe-identity api-key-id]]
    ;; Close the sidebar if revoked key was open
    (let [sidebar (get-in db [:qpes qpe-identity :ui :sidebar])]
      (if (and (= :new-api-key (:type sidebar))
               (= api-key-id (:id (:new-api-key sidebar))))
        {:db (update-in db [:qpes qpe-identity :ui] dissoc :sidebar)}
        {}))))

(rf/reg-event-db
  :qsm/api-keys
  (fn [db [_ {:keys [qpe_identity api-keys]}]]
    (assoc-in db [:qpes qpe_identity :api-keys] api-keys)))
